import {IDirective, IDirectiveFactory} from 'angular';
import moment from 'moment';
import INgModelController = angular.INgModelController;
import Moment = moment.Moment;
let template = require('./dv-datepicker.html');

export class DVDatepicker implements IDirective {
    restrict = 'E';
    require: any = {ngModelCtrl: 'ngModel'};
    scope = {
        ngModel: '=',
        inputId: '@',
        ngRequired: '<',
        checkFuture: '<',
        checkPast: '<',
        placeholder: '@',
        ngDisabled: '<',
        dvOnBlur: '&?'
    };
    controller = DatepickerController;
    controllerAs = 'vm';
    bindToController = true;
    template = template;
    /* constructor() { this.link = this.unboundLink.bind(this); }*/
    static factory(): IDirectiveFactory {
        const directive = () => new DVDatepicker();
        directive.$inject = [];
        return directive;
    }
}
export class DatepickerController {
    static $inject: string[] = [];
    date: Date;
    ngModelCtrl: INgModelController;
    dateRequired: boolean;
    ngRequired: boolean;
    checkFuture: boolean;
    checkPast: boolean;
    placeholder: string | undefined;
    dvOnBlur: () => void;
    static allowedFormats: string[] = ['D.M.YYYY', 'DD.MM.YYYY'];
    static defaultFormat: string = 'DD.MM.YYYY';

    constructor() {
    }

    // beispiel wie man auf changes eines attributes von aussen reagieren kann
    $onChanges(changes: any) {
        if (changes.ngRequired && !changes.ngRequired.isFirstChange()) {
            this.dateRequired = changes.ngRequired.currentValue;
        }

    }

    //wird von angular aufgerufen
    $onInit() {
        if (!this.ngModelCtrl) {
            return;
        }

        //wenn kein Placeholder gesetzt wird wird der standardplaceholder verwendet. kann mit placeholder="" ueberscrieben werden
        if (this.placeholder === undefined) {
            this.placeholder = 'tt.mm.jjjj';
        } else if (this.placeholder === '') {
            this.placeholder = undefined;
        }

        if (this.ngRequired) {
            this.dateRequired = this.ngRequired;
        }

        this.ngModelCtrl.$render = () => {
            this.date = this.ngModelCtrl.$viewValue;
        };
        this.ngModelCtrl.$formatters.unshift(DatepickerController.momentToString);
        this.ngModelCtrl.$parsers.push(DatepickerController.stringToMoment);

        this.ngModelCtrl.$validators['moment'] = (modelValue: any, viewValue: any) => {
            // if not required and view value empty, it's ok...
            if (!this.dateRequired && !viewValue) {
                return true;
            }
            let value = modelValue || DatepickerController.stringToMoment(viewValue);
            return moment(value, DatepickerController.allowedFormats, true).isValid();
        };

        this.ngModelCtrl.$validators['future'] = (modelValue: any, viewValue: any) => {
            // if no check do nothing
            if (!this.checkFuture) {
                return true;
            }
            // if not required and view value empty, it's ok...
            if (!viewValue) {
                return true;
            }
            // as longn not valid, don't check future
            let value = modelValue || DatepickerController.stringToMoment(viewValue);
            let date: Moment = moment(value, DatepickerController.allowedFormats, true);
            if (!date.isValid()) {
                return true
            }
            return moment.now() > date.valueOf();
        };

        this.ngModelCtrl.$validators['past'] = (modelValue: any, viewValue: any) => {
            // if no check do nothing
            if (!this.checkPast) {
                return true;
            }
            // if not required and view value empty, it's ok...
            if (!viewValue) {
                return true;
            }
            // as longn not valid, don't check past
            let value = modelValue || DatepickerController.stringToMoment(viewValue);
            let date: Moment = moment(value, DatepickerController.allowedFormats, true);
            if (!date.isValid()) {
                return true
            }
            return moment().startOf('day').unix() <= date.valueOf() / 1000;
        };
    }

    onBlur() {
        if (this.dvOnBlur) { // userdefined onBlur event
            this.dvOnBlur();
        }
        this.ngModelCtrl.$setTouched();
    }

    updateModelValue() {
        this.ngModelCtrl.$setViewValue(this.date);
    };

    private static momentToString(mom: Moment): string {
        if (mom && mom.isValid()) {
            return mom.format(DatepickerController.defaultFormat);
        }
        return '';
    }

    private static stringToMoment(date: string): any {
        if (moment(date, DatepickerController.allowedFormats, true).isValid()) {
            return moment(date, DatepickerController.allowedFormats, true);
        }
        return null;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/directive/dv-datepicker/dv-datepicker.ts